import { TReplaceOptions } from 'legacy/lut/library/translation/models/replaceOptions'

import { IPartnersCompleteness } from '../models/IPartnersCompleteness'

export const getReplaceParams = (
  partnersCompleteness?: IPartnersCompleteness
): TReplaceOptions[] => {
  const replaceParams = [
    { key: '{programType}', value: partnersCompleteness?.programType || '' },
    { key: '{partnersCount}', value: (partnersCompleteness?.partnersCount || 0).toString() },
    {
      key: '{partnersCompleted}',
      value: (partnersCompleteness?.partnersCompleted || 0).toString(),
    },
    {
      key: '{partnersNotCompleted}',
      value: (partnersCompleteness?.partnersNotCompleted || 0).toString(),
    },
    {
      key: '{partnersCountAck}',
      value: (partnersCompleteness?.partnersCountAcknowledged || 0).toString(),
    },
    {
      key: '{partnersCountNotAck}',
      value: (partnersCompleteness?.partnersCountNotAcknowledged || 0).toString(),
    },
    {
      key: '{partnersCompletedAck}',
      value: (partnersCompleteness?.partnersCompletedAcknowledged || 0).toString(),
    },
    {
      key: '{partnersNotCompletedAck}',
      value: (partnersCompleteness?.partnersNotCompletedAcknowledged || 0).toString(),
    },
    {
      key: '{partnersNotFullyCompleted}',
      value: (partnersCompleteness?.partnersNotFullyCompleted || 0).toString(),
    },
  ]

  return replaceParams
}
